<form [formGroup]="form">
  @if (viewMode === 'modal') {
    <ng-container [ngTemplateOutlet]="displayName"></ng-container>
    <ng-container [ngTemplateOutlet]="bucketName"></ng-container>
    <ng-container [ngTemplateOutlet]="companies"></ng-container>
  } @else {
    <mbs-card class="card-form">
      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="displayName"></ng-container>
      </mbs-card-group>

      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="bucketName"></ng-container>
      </mbs-card-group>

      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="companies"></ng-container>
      </mbs-card-group>
    </mbs-card>
  }

  <ng-template #companies>
    @if (!hideCompanies) {
      <div class="mbs-form-group">
        <h5
          class="mb-0"
          [class.text-disabled]="destination?.isReadOnly">
          {{ 'shared:common.companies' | i18next: { format: 'title' } }}
        </h5>
        <div
          class="mb-2"
          [class.text-disabled]="destination?.isReadOnly">
          {{ 'shared:modals.addDestinationBucket.companyExplanation' | i18next }}
        </div>

        <mbs-companies-picker
          [allowEmptySelection]="true"
          [companiesControl]="$any(form.get('companies'))"
          [disabled]="companiesLocked || destination?.isReadOnly"
          [selectedIds]="selectedCompanyIds"></mbs-companies-picker>
      </div>
    }
  </ng-template>

  <ng-template #displayName>
    <div class="mbs-form-group">
      <mbs-input
        formControlName="displayBucketName"
        [attr.data-e2e]="e2eLocators.displayBucketNameControl"
        [boldLabel]="true"
        [label]="'shared:modals.addDestinationBucket.destinationDisplayName' | i18next: { format: 'capitalize' }"
        [placeholder]="'shared:modals.addDestinationBucket.displayNamePlaceholder' | i18next: { format: 'capitalize' }"
        [showRequiredMark]="false"></mbs-input>
    </div>
  </ng-template>

  <ng-template #bucketName>
    <div [class.mbs-form-group]="viewMode === 'modal'">
      @if (storageAccount?.storageType === StorageType.AzureVM) {
        <div>
          <h5 class="m-0">
            {{ 'shared:modals.addDestinationBucket.bucketName' | i18next: { format: 'capitalize', type: rootFolderName } }}
          </h5>
          <div>{{ form?.value?.bucketName }}</div>
        </div>
      } @else {
        <mbs-input
          formControlName="bucketName"
          [attr.data-e2e]="e2eLocators.bucketNameControl"
          [boldLabel]="true"
          [label]="
            storageAccount.storageType === StorageType.LocalFS
              ? rootFolderName
              : ('shared:modals.addDestinationBucket.rootFolderLabel' | i18next: { format: 'capitalize', type: rootFolderName })
          "
          [placeholder]="
            (storageAccount.storageType === StorageType.LocalFS
              ? 'shared:modals.addDestinationBucket.enterBucketNameFS'
              : 'shared:modals.addDestinationBucket.enterBucketNameFTP'
            ) | i18next
          "
          [showRequiredMark]="false"></mbs-input>
      }
    </div>
  </ng-template>
</form>
